const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const calendarHost = publicConfig.external_address;

const Calendar = {
  /**
   * Read booking availability by month and year
   *
   * @function
   * @name read
   * @param {string}   - query
   * @param {string} - token
   * @param {function}  - callback
   */

  readAnonymous: (query, callback) => {
    const params = {
      host: calendarHost,
      method: 'GET',
      path: `/v1/calendar/${query}`
    };
    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  readCalendar: (query, token, callback) => {
    const params = {
      host: calendarHost,
      method: 'GET',
      path: `/v1/calendar/${query}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  createCalendarPricing: (payload, listingId, token, callback) => {
    const params = {
      host: calendarHost,
      method: 'POST',
      path: `/v2/spaces-v2/listings/${listingId}/calendar-pricing`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  postBlockDay: (payload, token, callback) => {
    const params = {
      host: calendarHost,
      method: 'POST',
      path: '/v1/calendar/events/',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  deleteCalendar: (query, token, callback) => {
    const params = {
      host: calendarHost,
      method: 'DELETE',
      path: `/v1/calendar/${query}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  deleteBlockDay: (groupId, token, callback) => {
    const params = {
      host: calendarHost,
      method: 'DELETE',
      path: `/v2/spaces-v2/listings/calendar-pricing/group/${groupId}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  getOpHours: (spaceId, token, callback) => {
    const params = {
      host: calendarHost,
      method: 'GET',
      path: `/v1/calendar/ophours/space/${spaceId}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  fetchCalendarSurveyData: (spaceId, token, callback) => {
    const params = {
      host: calendarHost,
      method: 'GET',
      path: `/v1/calendar/survey/${spaceId}/data`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  updateCalendarUsage: (spaceId, token, payload, callback) => {
    const params = {
      host: calendarHost,
      method: 'PUT',
      path: `/v1/calendar/survey/${spaceId}/usage`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  updateCalendarSyncReasons: (spaceId, token, payload, callback) => {
    const params = {
      host: calendarHost,
      method: 'PUT',
      path: `/v1/calendar/survey/${spaceId}/sync/reasons`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  updateCalendarSyncReminder: (spaceId, token, payload, callback) => {
    const params = {
      host: calendarHost,
      method: 'PUT',
      path: `/v1/calendar/survey/${spaceId}/sync/reminders`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  }
};

module.exports = Calendar;
